'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIButtonWrapper = require('../layout/UIButtonWrapper');

var _UIButtonWrapper2 = _interopRequireDefault(_UIButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};

var getLayoutType = function getLayoutType(className, layout) {
  if (layout) return layout;

  if (className) {
    _devLogger2.default.warn({
      message: 'UIDialogFooter: Button layout is now improved out-of-the-box, but ' + "we didn't want to risk breaking any custom styling in your app. " + 'Remove this warning by setting layout="default" and seeing if you ' + 'still need your custom styles added via "className" or set it to ' + 'layout="legacy" to keep everything as it was.',
      key: 'UIDialogFooter: check classNames'
    });
    return 'legacy';
  }

  return 'default';
};

exports.default = _react2.default.createClass({
  displayName: 'UIDialogFooter',

  propTypes: {
    align: _react.PropTypes.oneOf(['left', 'center', 'right', 'between']).isRequired,
    children: _react.PropTypes.node,
    layout: _UIButtonWrapper2.default.propTypes.layout
  },

  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left'
    };
  },
  render: function render() {
    var _props = this.props,
        align = _props.align,
        children = _props.children,
        className = _props.className,
        layout = _props.layout,
        rest = _objectWithoutProperties(_props, ['align', 'children', 'className', 'layout']);

    return _react2.default.createElement(
      'footer',
      _extends({}, rest, {
        className: (0, _classNames2.default)('private-modal__footer', 'uiDialogFooter', className)
      }),
      _react2.default.createElement(
        _UIButtonWrapper2.default,
        {
          justify: ALIGNMENT_OPTIONS[align],
          layout: getLayoutType(className, layout)
        },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/dialog/UIDialogFooter.js
// module id = 546
// module chunks = 171